import { EngineOutput } from "../model/model";

export function convertToEngineOutput(item: any): EngineOutput {
  return {
    phaseSmartCommissionGross: item.phase_smart_commission_gross,
    phaseSmartHighlightCommissionGross: item.phase_smart_highlight_commission_gross,
    phaseSmartHighlightExtraGross: item.phase_smart_highlight_extra_gross,
    phaseSmartPromoteGross: item.phase_smart_promote_gross,
    phaseSmartSpecialZoneCommissionGross: item.phase_smart_special_zone_commission_gross,
    phaseSmartSpecialZoneMarkGross: item.phase_smart_special_zone_mark_gross,
    phaseSmartCoinsGross: item.phase_smart_coins_gross,
    phaseSmartPublishingGross: item.phase_smart_publishing_gross,
    phaseSmartDeliveryGross: item.phase_smart_delivery_gross,
    phaseSmartAllegroPayGross: item.phase_smart_allegro_pay_gross,
    phaseSmartAllegroAdsGross: item.phase_smart_allegro_ads_gross,
    unitaryTransactionCostGross: item.unitary_transaction_cost_gross,
    phaseNonSmartCommissionGross: item.phase_non_smart_commission_gross,
    phaseNonSmartHighlightCommissionGross: item.phase_non_smart_highlight_commission_gross,
    phaseNonSmartPromoteGross: item.phase_non_smart_promote_gross,
    phaseNonSmartSpecialZoneCommissionGross: item.phase_non_smart_special_zone_commission_gross,
    phaseNonSmartSpecialZoneMarkGross: item.phase_non_smart_special_zone_mark_gross,
    phaseNonSmartCoinsGross: item.phase_non_smart_coins_gross,
    phaseNonSmartPublishingGross: item.phase_non_smart_publishing_gross,
    phaseNonSmartDeliveryGross: item.phase_non_smart_delivery_gross,
    phaseNonSmartAllegroPayGross: item.phase_non_smart_allegro_pay_gross,
    phaseNonSmartAllegroAdsGross: item.phase_non_smart_allegro_ads_gross,
    companyIncomeTax: item.company_income_tax,
    companyZus: item.company_zus,
    allegroSmartPercentUpdated: item.allegro_smart_percent_updated,
    phaseProductsSoldSmart: item.phase_products_sold_smart,
    phaseProductsSoldNonSmart: item.phase_products_sold_non_smart,
    phaseProductNetRevenue: item.phase_product_net_revenue,
    phaseUnitaryCostsSmartNet: item.phase_unitary_costs_smart_net,
    phaseUnitaryCostsSmartGross: item.phase_unitary_costs_smart_gross,
    phaseUnitaryCostsNonSmartNet: item.phase_unitary_costs_non_smart_net,
    phaseUnitaryCostsNonSmartGross: item.phase_unitary_costs_non_smart_gross,
    phaseProductNetSmartIncome: item.phase_product_net_smart_income,
    phaseSmartIncomeTax: item.phase_smart_income_tax,
    phaseSmartZus: item.phase_smart_zus,
    phaseProductNetSmartProfit: item.phase_product_net_smart_profit,
    phaseProductNetNonSmartIncome: item.phase_product_net_non_smart_income,
    phaseNonSmartIncomeTax: item.phase_non_smart_income_tax,
    phaseNonSmartZus: item.phase_non_smartzus,
    phaseProductNetNonSmartProfit: item.phase_product_net_non_smart_profit,
    phaseProductNetSmartProfitTotal: item.phase_product_net_smart_profit_total,
    phaseProductNetNonSmartProfitTotal: item.phase_product_net_s_non_smart_profit_total,
    phaseHighlightCommissionNet: item.phase_highlight_commision_net, //TODO: fix typo in api
    phaseHighlightExtraNet: item.phase_highlight_extra_net,
    phasePromoteNet: item.phase_promote_net,
    phaseSpecialZoneCommissionNet: item.phase_special_zone_commission_net,
    phaseSpecialZoneMarkNet: item.phase_special_zone_mark_net,
    phaseCoinsNet: item.phase_coins_net,
    phasePublishingNet: item.phase_publishing_net,
    phaseDeliveryNet: item.phase_delivery_net,
    phaseAllegroPayNet: item.phase_allegro_pay_net,
    phaseAllegroAdsNet: item.phase_allegro_ads_net,
    packagingCostNet: item.packaging_cost_net,
    unitaryTransactionCostNet: item.unitary_transaction_cost_net,
    phaseNonSmartHighlightExtraGross: item.phase_non_smart_highlight_extra_gross,
    phaseCommissionNet: item.phase_commision_net, //TODO: fix typo in api
    productCostNet: item.product_cost_net,
    phaseIncomeTaxNet: item.phase_income_tax_net,
    phaseCompanyZusNet: item.phase_company_zus_net,
    phaseMarginNetSmart: item.phase_margin_net_smart,
    phaseMarginNetNonSmart: item.phase_margin_net_non_smart,
  };
}